/** API Village ↔ UI village master fields. */

export function villageDisplayId(row) {
  if (!row) return '';
  if (row.code) return String(row.code);
  if (row.id != null) return `V-${String(row.id).padStart(3, '0')}`;
  return '';
}

export function villageFromApi(row) {
  if (!row) return null;
  return {
    id: row.id,
    villageId: villageDisplayId(row),
    villageName: row.name ?? '',
    talukaName: row.talukaName ?? '',
    district: row.district ?? '',
    state: row.state ?? '',
    country: row.country ?? '',
    gramPanchayat: row.gramPanchayat ?? '',
    pin: row.pin ?? '',
    category: row.category ?? '',
    googlePlaceId: row.googlePlaceId ?? null,
    latitude: row.latitude != null ? Number(row.latitude) : null,
    longitude: row.longitude != null ? Number(row.longitude) : null,
    boundary: row.boundary ?? null,
    active: row.isActive !== false,
    createdAt: row.createdAt ?? null,
    updatedAt: row.updatedAt ?? null,
  };
}

export function villageToApi(ui) {
  if (!ui) return null;
  const body = {
    name: ui.villageName,
    talukaName: ui.talukaName || null,
    district: ui.district || null,
    state: ui.state || null,
    country: ui.country || null,
    gramPanchayat: ui.gramPanchayat || null,
    pin: ui.pin || null,
    category: ui.category || null,
    googlePlaceId: ui.googlePlaceId || null,
    latitude:
      ui.latitude != null && ui.latitude !== '' ? Number(ui.latitude) : null,
    longitude:
      ui.longitude != null && ui.longitude !== '' ? Number(ui.longitude) : null,
    isActive: ui.active !== false,
  };
  const code = ui.code || ui.villageId;
  if (code) body.code = code;
  // Only send a real GeoJSON object — omit null so DTO oneOf does not reject.
  if (
    ui.boundary &&
    typeof ui.boundary === 'object' &&
    !Array.isArray(ui.boundary) &&
    (ui.boundary.type === 'Polygon' ||
      ui.boundary.type === 'MultiPolygon' ||
      ui.boundary.type === 'Feature' ||
      ui.boundary.type === 'FeatureCollection')
  ) {
    body.boundary = ui.boundary;
  }
  return body;
}
